import { useRef } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { commissionSplitsService } from "services";
import { uiActions } from "store";
import { CommissionSplit, ErrorResponse, ListResponseDto } from "types";

type UpdateStatusCommissionSplitParams = {
	commissionId: string;
	agentId: string;
	active: boolean;
};

const useUpdateStatusCommissionSplitQuery = ({ fetchData }) => {
	const dispatch = useDispatch();
	const queryClient = useQueryClient();
	const rowSelectedCommission = useRef<string | null>(null);
	const { page, sortBy } = fetchData;
	const mutation = useMutation(
		(data: UpdateStatusCommissionSplitParams) => {
			const { commissionId, agentId, active } = data;
			rowSelectedCommission.current = commissionId;
			return commissionSplitsService.updateStatusCommissionSplits({
				active,
				agentId,
				commissionId,
			});
		},
		{
			onMutate: async newValue => {
				return newValue;
			},
			onSuccess: (result, variables, newValue) => {
				queryClient.setQueryData(
					["getCommissionSplits", page, sortBy],
					(oldValues?: ListResponseDto<CommissionSplit>) => {
						if (!oldValues) {
							return { count: 0, items: [] };
						}
						return {
							count: oldValues?.count,
							items: oldValues?.items.map(oldValue =>
								oldValue.id === newValue?.commissionId
									? {
											...oldValue,
											is_available: newValue?.active,
									  }
									: oldValue,
							),
						};
					},
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);

	const { mutate, isLoading } = mutation;
	return {
		mutate,
		isLoading,
		rowSelectedCommission: rowSelectedCommission.current,
	};
};

export default useUpdateStatusCommissionSplitQuery;
